"use strict";

var _EnvironmentProvider, _AuthProvider;
import { AuthProvider, createClient, withRequiredAuthentication } from '@autoguru/auth';
import { getToken } from '@autoguru/auth/relay';
import { ContactNumbersProvider, PageLoading } from '@autoguru/components';
import { PriceDisplaySettingsProvider } from '@autoguru/pricing-display';
import { EnvironmentProvider, createEnvironment } from '@autoguru/relay';
import { SupplierProvider, SupplierRequiredBoundary } from '@autoguru/supplier-provider';
import { AsyncBoundary } from '@autoguru/suspense';
import { ViewerAccountProvider } from '@autoguru/viewer-preferences';
import SupplierDashboardRoutes from '~/src/pages';
import { jsx as _jsx } from "react/jsx-runtime";
const authClient = createClient();
const relayModernEnvironment = createEnvironment({
  fetcherOptions: {
    getToken
  }
});
const AuthRequiredApp = withRequiredAuthentication(() => _EnvironmentProvider || (_EnvironmentProvider = /*#__PURE__*/_jsx(EnvironmentProvider, {
  environment: relayModernEnvironment,
  children: /*#__PURE__*/_jsx(AsyncBoundary, {
    fallback: PageLoading,
    children: /*#__PURE__*/_jsx(ViewerAccountProvider, {
      children: /*#__PURE__*/_jsx(SupplierProvider, {
        children: /*#__PURE__*/_jsx(PriceDisplaySettingsProvider, {
          priceDisplaySetting: "INCLUDING_TAX",
          children: /*#__PURE__*/_jsx(SupplierRequiredBoundary, {
            children: /*#__PURE__*/_jsx(SupplierDashboardRoutes, {})
          })
        })
      })
    })
  })
})), true);
export const App = () => _AuthProvider || (_AuthProvider = /*#__PURE__*/_jsx(AuthProvider, {
  allow_socials: false,
  client: authClient,
  children: /*#__PURE__*/_jsx(ContactNumbersProvider, {
    children: /*#__PURE__*/_jsx(AsyncBoundary, {
      fallback: PageLoading,
      children: /*#__PURE__*/_jsx(AuthRequiredApp, {})
    })
  })
}));